import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import HamburgerMenuButton from "./HamBurgerMenuButton";
import OffcanvasMenu from "./OffcanvasMenu";
import '../../css/NavBar.css';
import { useAuth } from "../../state/AuthContext";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../services/UserService.ts"; 

function NavBar() {
    const [isCompact, setIsCompact] = useState(window.innerWidth <= 1024);
    const [offcanvasOpen, setOffcanvasOpen] = useState(false);
    const { isLoggedIn, logout, checkAuth, loading } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        const handleResize = () => {
            setIsCompact(window.innerWidth <= 1024);
        };
        window.addEventListener("resize", handleResize);
        checkAuth();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const location = useLocation();
    const isContent = /^\/(basic|advanced)\/\d+/.test(location.pathname);

    const contentInfo = isContent ? formatContentInfo(location.pathname) : null;

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <header className="site-header" style={{ border: "1px solid black" }}>
            <nav className={isContent ? "navbar content-navbar" : "navbar"}>
                <div className="navbar-logo">
                    <img src="/assets/images/simple_boat.png" alt="Logo" className="logo-icon" />
                    <Link to="/" className="logo-text">D-Smart</Link>
                    {isContent && contentInfo && (
                        <>
                            <span className="content-navbar-text">
                              <span className="content-info-section"> {contentInfo.section} </span> / <span className="content-info-title">{contentInfo.title}</span>
                            </span>
                        </>
                    )}
                </div>
                {!isContent && (
                    <ul className="navbar-links">
                        <li className="dropdown" id="home">
                            <a href="/" className="dropdown-toggle" id="home" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                                Learn <span className="caret"></span>
                            </a>
                            <ul className="dropdown-menu" id="home">
                                <li><a href="/basic">Basic Content</a></li>
                                <li><a href="/advanced">Advanced Content</a></li>
                            </ul>
                        </li>
                        <li><a href="https://d-smart.cls.chalmers.se/chat/">Practice</a></li>
                        <li><a href="/">Publications</a></li>
                        <li><a href="/">About Us</a></li>
                    </ul>
                )}
                {!isContent && (
                    <div className="navbar-actions">
                        {/* <button className="navbar-icon" aria-label="Search">
                            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <circle cx="11" cy="11" r="7" stroke="#94A3B8" strokeWidth="2" />
                                <line x1="16.5" y1="16.5" x2="22" y2="22" stroke="#94A3B8" strokeWidth="2" />
                            </svg>
                        </button> */}
                        {!isCompact && (
                            <>
                                {/* <button className="navbar-icon" aria-label="Refresh">
                                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                        <path d="M17.65 6.35A8 8 0 1 0 12 20" stroke="#94A3B8" strokeWidth="2" fill="none" />
                                        <polyline points="17 1" stroke="#94A3B8" strokeWidth="2" fill="none" />
                                    </svg>
                                </button> */}
                                {isLoggedIn && (
                                <Link to="/profile">
                                    <button className="navbar-icon" aria-label="Profile">
                                    <i className="bi bi-person-circle" style={{ fontSize: "1.5rem" }}></i>
                                    </button>
                                </Link>
                                )}
                                {isLoggedIn ? (
                                <button className="navbar-signup" onClick={async () => {
                                    try {
                                        await logoutUser();
                                        logout();
                                        navigate("/");
                                    } catch (error) {
                                        console.error("Logout failed:", error);
                                    }
                                }}>Log Out</button>
                                ) : (
                                <Link to="/login">
                                    <button className="navbar-signup">Sign In</button>
                                </Link>
                                )}
                            </>
                        )}
                        {isCompact && (
                            <HamburgerMenuButton onClick={() => setOffcanvasOpen(true)} />
                        )}
                        <OffcanvasMenu open={offcanvasOpen} onClose={() => setOffcanvasOpen(false)} />
                    </div>
                )}
            </nav>
        </header>
    );
}

function formatContentInfo(pathname) {
    const match = pathname.match(/^\/(basic|advanced)\/([^/]+)/);
    if (!match) return null;
    const section = match[1];
    const slug = match[2]
        .replace(/^\d+-/, '')
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
    return {
        section: section,
        title: slug
    };
}

export default NavBar;